import apiClient from './apiClient';

export const authService = {
  login: (credentials) => apiClient.post('/admin/auth/login', credentials),
  logout: () => apiClient.post('/admin/auth/logout'),
  me: () => apiClient.get('/admin/auth/me'),
  refresh: () => apiClient.post('/admin/auth/refresh'),
};

export default authService;
